import { FuelCalibrationOutputByIdOutPut } from './fuel-calibration-output-by-id-out-put.model';


export class FuelCalibrationSelectByIdOutput implements IFuelCalibrationSelectByIdOutput {
    status!: number;
    message!: string;
    data!: FuelCalibrationOutputByIdOutPut;

    constructor(data?: IFuelCalibrationSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? FuelCalibrationOutputByIdOutPut.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FuelCalibrationSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new FuelCalibrationSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFuelCalibrationSelectByIdOutput {
    status: number;
    message: string;
    data: FuelCalibrationOutputByIdOutPut;
}

